<template>
  <div class="stage-wrapper">
    <div class="flex align-center justify-between stage-title margin-bottom-sm">
      <h3>{{ stageTitle }}</h3>
      <i class="el-icon-circle-plus" :class="'active' + stageNum" @click="addTarget('','')"></i>
    </div>
    <div v-if="stageList.length>0">
      <draggable v-model="stageList" @end="onEnd">
        <transition-group >
          <div v-for="(item,index) in stageList" v-bind:key="item.id">
            <div class="stage-item" :class="['active' + stageNum, activeId === item.id?'chiose':'']"
                 @click="setActive(item.id)">
              <div class="flex align-center justify-between stage-item-index">
                <div class="stage-item-name">{{ index + 1 }}.{{ item.name }}<br/><i :class="'active' + stageNum">({{ item.total_points }}分)</i></div>
                <el-dropdown @command="itemClick">
                <span class="el-dropdown-link">
                 <i class="el-icon-edit"></i>
                </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="{set:'edit',id:item.id,name:item.name}">编辑</el-dropdown-item>
                    <el-dropdown-item :command="{set:'del',id:item.id}">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>

              </div>
<!--              <div class="stage-item-name">-->

<!--              </div>-->
            </div>
          </div>
        </transition-group>
      </draggable>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import {indicatorsDel, indicatorsList, indicatorsSave, setSort} from "@/api/admin";

export default {
  name: "stageModular",
  data() {
    return {
      stageList: [],
      activeId: '',
    }
  },
  props: {
    stageTitle: {
      type: String,
    },
    stageNum: {
      type: Number,
      default: () => {
        return 1
      }
    },
    infoId: {
      type: Number,
      default: () => {
        return 0
      }
    },
    parentId: {
      type: Number,
      default: () => {
        return 0
      }
    },

  },
  created() {
    this.getStage()
    this.activeId = ''
  },
  components: {draggable},
  methods: {
    //  指标编辑
    itemClick(command) {
      if (command.set === 'edit') {
        this.addTarget(command.id, command.name)
      } else {
        this.deleteItem(command.id)
      }
    },

    //  删除指标
    deleteItem(id) {
      this.$confirm('您确定要删除该指标信息吗？', "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureDelete(id);
      });
    },
    async sureDelete(id) {
      let _state = await indicatorsDel(this.stageNum, id);
      if (_state.status === 200) {
        this.$emit('delTarget', this.stageNum)
        this.activeId = ''
        this.getStage();
      }
    },
    //  选择指标
    setActive(id) {
      this.activeId = id
      this.$emit('chioseTarget', [this.stageNum, id])
    },
    //  添加指标
    addTarget(id, str) {
      this.$prompt('请输入指标名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: str,
        closeOnClickModal: false,
      }).then(({value}) => {
        if(value) this.submitTarget(id, value)
      })
    },
    async submitTarget(id, str) {
      const res = await indicatorsSave(this.infoId, this.stageNum, this.parentId, str, id)
      if (res.status === 200) {
        this.$message.success('编辑成功')
        this.getStage()
      }
    },
    //  获取指标列表
    async getStage() {
      const res = await indicatorsList(this.infoId, this.stageNum, this.parentId)
      this.stageList = res.data
    },
    async onEnd() {
      let _arr = []
      this.stageList.map(item=>{
        _arr.push(item.id)
      })
      const res = await setSort(this.infoId, this.stageNum,_arr.join(','))
      if(res.status === 200) this.$message.success('排序操作成功')
    },
  },
  filters: {},
  watch: {
    parentId() {
      this.activeId = ''
      if (this.parentId) {
        this.getStage()
      }
    }
  },
}
</script>

<style scoped lang="scss">
.stage-wrapper {
  width: calc((100vw - 350px) / 6);
  margin-right: 10px;
  min-height: calc(100vh - 250px);
  background-color: #f5f5f5;
  border-radius: 10px;
  padding: 12px;

  .stage-title {
    i {
      font-size: 20px;
      color: #368ad1;

      &.active2 {
        color: #7ecd86
      }

      &.active3 {
        color: #ffa200
      }

      &.active4 {
        color: #f06363
      }
    }
  }

  .stage-item {
    min-height: 43px;
    background-color: #ffffff;
    border-radius: 10px;
    margin-bottom: 10px;
    border-left: 5px solid #368ad1;
    padding: 10px;
    cursor: pointer;

    &.chiose {
      background: rgba(#368ad1, .2);
    }

    &.active2 {
      border-color: #7ecd86;
    }

    &.active3 {
      border-color: #ffa200;

    }

    &.active4 {
      border-color: #f06363;

    }

    &.active2.chiose {

      background: rgba(#7ecd86, .2);
    }

    &.active3.chiose {

      background: rgba(#ffa200, .2);
    }

    &.active4.chiose {

      background: rgba(#ffa200, .2);
    }

    .stage-item-index {
      .stage-item-name {
        font-size: 14px;
        line-height: 150%;
        flex: 1;
        margin-right: 10px;

        i {
          color: #368ad1;

          &.active2 {
            color: #7ecd86
          }

          &.active3 {
            color: #ffa200
          }

          &.active4 {
            color: #f06363
          }
        }
      }
      i {
        font-size: 16px;
        cursor: pointer;
      }
    }


  }

}
</style>
